var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['preloader', _vm.modify]},[_c('div',{staticClass:"preloader__spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }